import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationRU from './locales/ru/translation.json';
import translationEN from './locales/en/translation.json';
import translationAR from './locales/ar/translation.json';
import translationDE from './locales/de/translation.json';
import translationES from './locales/es/translation.json';
import translationPL from './locales/pl/translation.json';
import translationPT from './locales/pt/translation.json';
import translationUK from './locales/uk/translation.json';
import translationIT from './locales/it/translation.json';
import translationFR from './locales/fr/translation.json';
import translationZH from './locales/zh/translation.json';
import translationVI from './locales/vi/translation.json';
import translationHE from './locales/he/translation.json';
import translationFA from './locales/fa/translation.json';
import translationUZ from './locales/uz/translation.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: translationEN
            },
            ru: {
                translation: translationRU
            },
            ar: {
                translation: translationAR
            },
            de: {
                translation: translationDE
            },
            es: {
                translation: translationES
            },
            pl: {
                translation: translationPL
            },
            pt: {
                translation: translationPT
            },
            uk: {
                translation: translationUK
            },
            it: {
                translation: translationIT
            },
            fr: {
                translation: translationFR
            },
            zh: {
                translation: translationZH
            },
            vi: {
                translation: translationVI
            },
            he: {
                translation: translationHE
            },
            uz: {
                translation: translationUZ
            },
            fa: {
                translation: translationFA
            }
        },
        fallbackLng: 'en',
        lng: 'en',
        interpolation: {
            escapeValue: false,
        }
    });

export default i18n;
